import type {RowData} from '../types/RowData';

/**
 * Safely reads a cell's `.value` from a RowData entry without type assertions.
 *
 * Production rows spread the API's cell objects (`{value, style}`) under their column
 * keys with an `unknown` index-signature type, so `row.<columnKey>.value` does not
 * typecheck and a naive property access can throw when the column is absent (only
 * visible + predefined columns are present on a row). Returns undefined for missing
 * columns and non-object cells.
 *
 * Intended for selectDatagridRows predicates:
 * `(row) => getRowCellValue(row, 'itemType') === 'MATERIAL'`
 */
export const getRowCellValue = (row: RowData, columnKey: string): unknown => {
  const cell = row[columnKey];
  return typeof cell === 'object' && cell !== null && 'value' in cell ? cell.value : undefined;
};
